import axios from 'axios';
import { env } from '@/lib/env';

/**
 * Base URL for General settings (authapi or aistudio /api/settings).
 * Connected-mode for tickets + vibe lives here (Settings General tab).
 * Prod gateway: BACKEND_URL ends with /backend -> /backend/api/settings/general.
 */
export function getGeneralSettingsApiBase() {
  const backend = (env('REACT_APP_BACKEND_URL') || '').replace(/\/$/, '');
  if (!backend) return '';

  if (backend.endsWith('/backend')) {
    return `${backend}/api/settings/general`;
  }

  if (backend.endsWith('/api')) {
    return `${backend}/settings/general`;
  }

  return `${backend}/api/settings/general`;
}

const BASE = getGeneralSettingsApiBase();

/** @typedef {{ chat_connected_mode: 'connected' | 'disconnected', ticket_connected_mode: 'connected' | 'disconnected', default_connected_mode?: 'connected' | 'disconnected', updated_at?: string | null }} GeneralSettings */

/** @returns {Promise<GeneralSettings>} */
export async function fetchGeneralSettings() {
  const { data } = await axios.get(BASE);
  return data;
}

/**
 * @param {{ chat_connected_mode?: 'connected' | 'disconnected', ticket_connected_mode?: 'connected' | 'disconnected', default_connected_mode?: 'connected' | 'disconnected' }} patch
 * @returns {Promise<GeneralSettings>}
 */
export async function updateGeneralSettings(patch) {
  const { data } = await axios.patch(BASE, patch);
  return data;
}

export function isChatConnected(settings) {
  return (settings?.chat_connected_mode || settings?.default_connected_mode || 'connected') === 'connected';
}

export function isTicketConnected(settings) {
  return (settings?.ticket_connected_mode || settings?.default_connected_mode || 'connected') === 'connected';
}